import { FileDropError } from './FileDropError';
import { FileDropProgress } from './FileDropProgress';
import { FileDropSuccess } from './FileDropSuccess';

export const FileDropFile = {
  Success: FileDropSuccess,
  Progress: FileDropProgress,
  Error: FileDropError,
};
